import { SalesDashboardMessages } from "@/messages/salesDashboard/sales-dashboard.messages";
import { DateRange } from "@/types/date.types";

export const getDateRangeOptions = (messages: SalesDashboardMessages) => [
  { value: DateRange.TODAY, label: messages.today },
  { value: DateRange.CURRENT_MONTH, label: messages.currentMonth },
  { value: DateRange.CURRENT_YEAR, label: messages.currentYear },
];

export const getDateRangeMessages = (
  messages: SalesDashboardMessages
): Partial<Record<DateRange, string>> => ({
  [DateRange.TODAY]: messages.lastDay,
  [DateRange.CURRENT_MONTH]: messages.lastMonth,
  [DateRange.CURRENT_YEAR]: messages.lastYear,
});

export const colors = [
  "#1A73E8",
  "#4CAF50",
  "#fb8c00",
  "#344767",
  "orange",
  "yellow",
  "pink",
  "teal",
  "brown",
  "cyan",
  "magenta",
  "lime",
  "indigo",
  "violet",
  "gold",
  "silver",
  "beige",
  "maroon",
  "olive",
  "navy",
];
